module.exports = __webpack_public_path__ + "img/exclamation-alt.0a4246c5.svg";